/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavingsPlanItem extends models.SavingsPlanBase {
    getFixupPrototypeFunction() { return SavingsPlanItem.fixupPrototype; }

    static newInstance(model: Partial<SavingsPlanItem>): SavingsPlanItem {
        let obj = Object.assign(new SavingsPlanItem(), model);
        SavingsPlanItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavingsPlanItem>): SavingsPlanItem {
        if (!model) return null;
        return SavingsPlanItem.newInstance(<SavingsPlanItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavingsPlanItem) {
        if (!obj) return;

        models.SavingsPlanItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavingsPlanItem): boolean {
        if (models.SavingsPlanBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SavingsPlanItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.commitment_amount === undefined) {
            this.commitment_amount = 0;
        }
        if (this.upfront_cost === undefined) {
            this.upfront_cost = 0;
        }
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Scope of the savings plan
     */
    plan_scope: string;

    /**
     * Plan start date
     */
    start_date: Date;

    /**
     * Plan end date
     */
    end_date: Date;

    /**
     * Plan term
     */
    term: string;

    /**
     * Payment option
     */
    payment_option: string;

    /**
     * Committed spend per hour
     */
    commitment_amount: number;

    /**
     * Upfront cost of the plan
     */
    upfront_cost: number;

    /**
     * Currency of monetary values
     */
    currency: string;

    /**
     * Instance family (AWS compute plans)
     */
    instance_family: string;

    /**
     * Current provisioning/status of the plan
     */
    provisioning_state: string;

}
